import { rem } from "polished"
import styled from "styled-components"

export const ResumeContainer = styled.div`
  display: block;
  text-align: left;
  margin-right: ${rem(16)};
`

export const ResumeTitle = styled.div`
  font-size: ${rem(24)};
`
